var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLines({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 205,
    viewBox: "0 0 328 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 327.5,
    y: 204.5,
    width: 327,
    height: 204,
    rx: 19.5,
    transform: "rotate(180 327.5 204.5)",
    stroke: "url(#paint0_linear_441_24629)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_24629",
    x1: 582,
    y1: 298,
    x2: 656,
    y2: 410,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLines);
export default __webpack_public_path__ + "static/media/right-lines.31b85c1422382b87ec7e3842c11944e4.svg";
export { ForwardRef as ReactComponent };